import React from 'react';

import { Hyperlink } from '../../../../../components/atoms/Hyperlink';

import { categoriesToString, getLabel, getLabelScreenReader } from '../utils/Helper';
import { IPageDimension } from '../interfaces/IConnectedPagesGraphProperties';
import { ICoordinates } from '../../../../../types/ICoordinates';
import { IConnectedPage } from '../../../../../types/api/connectedPages/IConnectedPage';
import { ellipsis } from '../../../../StringUtils';

interface LeafNodeProperties {
  node: IConnectedPage;
  maxMinDimensions: IPageDimension;
  coordinates: ICoordinates;
  width: number;
  maxNumberOfCharactersBeforeEllipse: number;
  borderColorFromCategories?: string;
  ariaLabelPrefix: string;

  // Events
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>, url: string) => void;
  onCopy: (label: string) => void;
}

/**
 * Leaf Node to display childpages or pages for >complements etc.
 * depending on if onClick is passed:
 *  - if passed: render childpages that can open more pages for the ConnectedPages
 *  - not passed: Hyperlink which routes to the pages the node points to.
 */
export default class LeafNode extends React.PureComponent<LeafNodeProperties> {
  constructor(props: LeafNodeProperties) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(event: React.MouseEvent<HTMLAnchorElement>) {
    if (this.props.onClick) {
      this.props.onClick(event, this.props.node.pageLink.url);
    }
  }

  render() {
    return (
      <li className="connected-pages-graph__list-item">
        <div
          className="connected-pages-graph__child"
          style={{
            left: this.props.coordinates.x,
            top: this.props.coordinates.y,
            width: this.props.width,
            height: this.props.width,
            /* stylelint-disable value-keyword-case */
            maxWidth: this.props.maxMinDimensions.maxWidth,
            minWidth: this.props.maxMinDimensions.minWidth,
            maxHeight: this.props.maxMinDimensions.maxWidth,
            minHeight: this.props.maxMinDimensions.minWidth,
            /* stylelint-enable value-keyword-case */
            marginTop: (this.props.width / 2) * -1,
            marginLeft: (this.props.width / 2) * -1,
          }}
        >
          {this.props.onClick && typeof this.props.onClick === 'function'
            ? (
                <a
                  href={this.props.node.pageLink.url}
                  className="connected-pages-graph__child-link"
                  onClick={this.onClickHandler}
                  aria-label={getLabelScreenReader(
                    this.props.node.categories,
                    this.props.node.pageLink.name,
                    this.props.ariaLabelPrefix,
                  )}
                  onCopy={() =>
                    this.props.onCopy &&
                    this.props.onCopy(getLabel(this.props.node.categories, this.props.node.pageLink.name))}
                  style={{ borderColor: this.props.borderColorFromCategories }}
                >
                  {categoriesToString(this.props.node.categories)}
                  <span className="connected-pages-graph__link-text">
                    {ellipsis(this.props.node.pageLink.name, this.props.maxNumberOfCharactersBeforeEllipse)}
                  </span>
                </a>
              )
            : (
                <div
                  className="connected-pages-graph__related-pages-link"
                  style={{ borderColor: this.props.borderColorFromCategories }}
                >
                  {categoriesToString(this.props.node.categories)}
                  <Hyperlink
                    id={this.props.node.pageLink.url}
                    className="connected-pages-graph__current-item-link"
                    ariaLabel={getLabelScreenReader(
                      this.props.node.categories,
                      this.props.node.pageLink.name,
                      this.props.ariaLabelPrefix,
                    )}
                    to={this.props.node.pageLink.url}
                    onCopy={() =>
                      this.props.onCopy &&
                      this.props.onCopy(getLabel(this.props.node.categories, this.props.node.pageLink.name))}
                  >
                    <span className="connected-pages-graph__link-text">
                      {ellipsis(this.props.node.pageLink.name, this.props.maxNumberOfCharactersBeforeEllipse)}
                    </span>
                  </Hyperlink>
                </div>
              )}
        </div>
      </li>
    );
  }
}
